<template>
  <v-dialog v-model="afficher" persistent max-width="700">
    <v-card>
      <v-card-title class="headline">Nouveau passage en caisse</v-card-title>
      <v-card-text>
        <v-alert type="error" v-if="error != ''">{{ error }}</v-alert>
        <p>Remplissez les champs ci-dessous:</p>
        <v-text-field
          label="Montant payé"
          v-model="form.montant"
          type="number"
          step="0.01"
          filled
          rounded
        ></v-text-field>
        <v-date-picker
          v-model="datepicker"
          full-width
          first-day-of-week="1"
          :landscape="$vuetify.breakpoint.smAndUp"
          class="mt-2"
        ></v-date-picker>
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-if="mode == 'edit'"
          color="red darken-1"
          @click="deletePaiement"
          dark
          text
          :loading="loading"
        >Supprimer le paiement</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="black" text @click="$emit('fermer')">Annuler</v-btn>
        <v-btn color="green darken-1" @click="createPaiement" dark :loading="loading">Valider</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import moment from "moment/src/moment";
  import { db } from "@/firebase";
  import * as firebase from "firebase/app";

  export default {
    data: () => ({
      afficher: true,
      error: "",
      datepicker: moment().format("YYYY-MM-DD"),
      loading: false,
      form: {
        montant: "",
      },
    }),

    props: {
      mode: String,
      paiement: Object,
    },

    created() {
      if (this.mode == "edit") {
        this.form.montant = this.paiement.montant / 100;
        this.datepicker = moment(this.paiement.date.toDate()).format(
          "YYYY-MM-DD"
        );
      }
    },

    methods: {
      async deletePaiement() {
        this.loading = true;
        await db.doc("paiements/" + this.paiement.id).delete();
        this.loading = false;
        this.$emit("delete-paiement", this.paiement.id);
        this.$emit("fermer");
      },
      async createPaiement() {
        this.error = "";
        if (this.form.montant * 100 <= 0) {
          this.error = "Prix incorrect";
          return;
        }
        const montant = this.form.montant * 100;

        const date = firebase.firestore.Timestamp.fromDate(
          new Date(this.datepicker)
        );

        try {
          this.loading = true;

          if (this.mode == "create") {
            const res = await db.collection("paiements").add({
              montant: montant,
              date: date,
              clientId: this.$route.params.id,
            });
            this.$emit("add-paiement", {
              id: res.id,
              montant: montant,
              date: date,
            });
          }
          if (this.mode == "edit") {
            await db.doc("paiements/" + this.paiement.id).update({
              montant: montant,
              date: date,
            });
            this.$emit("edit-paiement", {
              id: this.paiement.id,
              montant: montant,
              date: date,
            });
          }

          this.loading = false;
          this.$emit("fermer");
        } catch (e) {
          this.loading = false;
          console.log(e);
          this.error = "Une erreur s'est produite.";
        }
      },
    },
  };
</script>

<style>
</style>
